// Guide page pack — mounts the React-rendered documentation.

import React from 'react';
import { createRoot } from 'react-dom/client';

import '../components/slack/slack.css';
import '../components/content/content.css';

import Guide from '../components/content/Guide';
import GuideSidebar from '../components/content/GuideSidebar';

let articleRoot = null;
let sidebarRoot = null;

function mount() {
  const article = document.getElementById('guide-article-mount');
  if (article) {
    const iconSrc = article.dataset.iconSrc || '';
    if (articleRoot) articleRoot.unmount();
    articleRoot = createRoot(article);
    articleRoot.render(<Guide iconSrc={iconSrc} />);
  }

  const sidebar = document.getElementById('guide-sidebar-mount');
  if (sidebar) {
    if (sidebarRoot) sidebarRoot.unmount();
    sidebarRoot = createRoot(sidebar);
    sidebarRoot.render(<GuideSidebar />);
  }
}

document.addEventListener('turbolinks:load', mount);
